import { compose } from 'redux';

import { PlaceholderSize } from 'modules/shared/types';
import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';

import { QUERY } from './carrousel-query';
import { CarrouseLoaderBuilder } from './carrousel-component-loader';
import { CarrouselProps } from '.';

const enhancer = compose<
    React.ComponentType<
        WithFetchDatasByIdFromCMSInputProps & {
            placeholderSize?: PlaceholderSize;
            compactResponsive?: boolean;
            largeLegend?: boolean;
        }
    >
>(WithFetchDatasByIdFromCMS<CarrouselProps>(QUERY, CarrouseLoaderBuilder, 'findCarrouselContent'));
export default enhancer;
